import { render, staticRenderFns } from "./myPoints.vue?vue&type=template&id=3469c410&scoped=true&"
import script from "./myPoints.vue?vue&type=script&lang=js&"
export * from "./myPoints.vue?vue&type=script&lang=js&"
import style0 from "./myPoints.vue?vue&type=style&index=0&id=3469c410&lang=scss&scoped=true&"
import style1 from "./myPoints.vue?vue&type=style&index=1&id=3469c410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3469c410",
  null
  
)

export default component.exports